// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__BqZLB","label":"LoadingOverlay_label__3pqI3"};